import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "É seguro? O produto é regulado?",
    a: "Sim. Os títulos são emitidos pela Companhia Securitizadora Allu Invest S.A. (CNPJ 62.446.127/0001-96), regulados pela CVM e divulgados pela Dexcap Investimentos (CNPJ 49.637.048/0001-02), plataforma autorizada sob a Resolução CVM nº 88/2022.",
  },
  {
    q: "Vou ter que assistir os 60 minutos inteiros?",
    a: "Idealmente sim. O link para cadastro será compartilhado no final. Se você realmente está interessado em divulgar um produto diferente e ser bem remunerado por isso, indicamos que assista tudo.",
  },
  {
    q: "Tem replay? Vocês mandam gravação depois?",
    a: "Não. É uma escolha consciente — a sessão é ao vivo, sem replay e sem gravação enviada. Quem perde, perde. Tem nova sessão toda semana.",
  },
  {
    q: "Vou ter que comprar alguma coisa ou gastar algum dinheiro?",
    a: "Não. Na live, vamos apresentar o programa de parceiros e responder um Q&A — fim. No final compartilhamos um link para quem quiser se aplicar para ser parceiro.",
  },
  {
    q: "Preciso ser certificado pra participar?",
    a: "Sim. O programa de parceiros é exclusivo para profissionais certificados (CFA, CGA, CFP, AAI ou equivalente). A sessão apresenta esse programa, então faz sentido que a sala seja de certificados também.",
  },
  {
    q: "Quanto eu posso ganhar como parceiro?",
    a: "A receita gerada depende exclusivamente do volume divulgado pelo parceiro. As regras de cálculo serão compartilhadas na Live.",
  },
  {
    q: "Isso é pirâmide?",
    a: "Não. Estamos falando aqui de produtos de crédito estruturado securitizado. É uma operação 100% lastreada em ativos e recebíveis reais originados na operação de assinaturas da Allu.",
  },
  {
    q: "Se eu não conseguir essa sessão, perco a chance?",
    a: "Não. Temos novas sessões toda semana. Mas: não garantimos até quando teremos vagas abertas para o programa de parceiros.",
  },
];

export const SelecaoFAQ = () => {
  return (
    <section className="bg-[#FAF8F5]">
      <div className="container-narrow py-16 sm:py-24">
        <div className="max-w-3xl mb-10 sm:mb-14">
          <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-500">
            Antes de reservar
          </div>
          <h2
            className="mt-4 text-3xl sm:text-4xl md:text-5xl font-bold text-[#112711] tracking-tight leading-[1.1]"
            style={{ letterSpacing: "-0.02em" }}
          >
            As perguntas que todo assessor faz.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-2xl border border-zinc-200 overflow-hidden data-[state=open]:ring-1 data-[state=open]:ring-zinc-300"
            >
              <AccordionTrigger className="px-5 sm:px-6 py-4 text-left text-base sm:text-lg font-semibold text-[#112711] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-5 sm:px-6 pb-5 text-sm sm:text-[15px] text-zinc-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
